import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import SubscribeFormFull from 'components/Forms/SubscribeFormFull';
import WpImage from 'components/WPImage';
import Icon from 'components/UI/Icon';
import { GUIDES_PAGE } from 'constants/urls';

import * as styles from './styles.module.scss';
import { section, inner } from 'sections/TemplatePost/Hero/hero.module.scss';

const Lead = ({ data, pageUrl, lang }) => {
  const {
    guideHero: {
      guideHeroBanner,
      guideHeroBackButton,
      guideHeroTitle,
      guideHeroDescription,
    },
  } = data;

  const fileUrl =
    data?.guideAttachFileToDownload?.mediaItemUrl ?? 'https://screver.com/404/';

  const backLinkUrl = useMemo(() => {
    if (lang.slug === 'de') {
      return `${GUIDES_PAGE}?locale=de`;
    } else if (lang.slug === 'en') {
      return GUIDES_PAGE;
    }
  }, [lang]);

  return (
    <section className={classnames(section)}>
      <div className="scr-wrap">
        <div className={classnames(inner)}>
          <div
            className={classnames(styles.leadHero, 'scr-template-hero-inner')}
          >
            <div
              className={classnames(
                styles.media,
                'scr-template-hero-inner__media'
              )}
            >
              <WpImage
                src={guideHeroBanner?.sourceUrl || '#'}
                alt={guideHeroBanner?.altText}
              />
            </div>

            <div className={classnames('scr-template-hero-inner__content')}>
              <Link
                className={classnames('scr-template-conten-btn-back scr-link')}
                to={backLinkUrl}
                id="link-template-back"
              >
                <Icon name="chevron-left" /> {guideHeroBackButton}
              </Link>

              <h3 className={classnames('scr-template-conten-title scr-h3')}>
                {guideHeroTitle}
              </h3>

              <div
                className={classnames(styles.description)}
                dangerouslySetInnerHTML={{
                  __html: guideHeroDescription,
                }}
              ></div>

              <div>
                <SubscribeFormFull
                  fileUrl={fileUrl}
                  articleTitle={guideHeroTitle}
                  pageUrl={pageUrl}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Lead;
